import { AnyAction } from 'redux';
import {
  GlobalActions,
  VersicherungsnehmerCommonInsuranceData,
} from '@ps20-frontend/shop-integration-redux';
import { FamilienStand, Tarifbereich } from '@ps20/bff-models';
import {
  App,
  determineAssekuranztarifFromTarifbereich,
  VhvVorbelegungdaten,
} from '@ps20-frontend/frontend-models';
import { IAppState } from '../appState';
import { VhvActions } from '../vhvActions';

export interface Versicherungsnehmer extends VersicherungsnehmerCommonInsuranceData {
  familienstand: FamilienStand;
  tarifbereich?: Tarifbereich;
}

export const versicherungsnehmerReducer = function (
  sectionState: Versicherungsnehmer = null,
  action: AnyAction,
  appState: IAppState,
): Versicherungsnehmer {
  switch (action.type) {
    case VhvActions.FAMILIENSTAND_CHANGED: {
      return {
        ...sectionState,
        familienstand: action.payload.familienstand,
      };
    }
    case VhvActions.GEBURTSDATUM_CHANGED: {
      return {
        ...sectionState,
        geburtsdatum: action.payload.geburtsdatum,
      };
    }
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA_AFTER_VV_LOAD:
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA: {
      return {
        ...sectionState,
        isAssekuranztarif: action.payload,
      };
    }
    case GlobalActions.TARIFBEREICH_CHANGED: {
      return {
        ...sectionState,
        tarifbereich: action.payload,
        isAssekuranztarif: determineAssekuranztarifFromTarifbereich(action.payload),
      };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VhvVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.VHV_V2 && actionPayload.angebotsId === appState.angebotsId) {
        let gebDatum = sectionState.geburtsdatum;
        if (actionPayload.geburtsdatumVn) {
          const dateSplitted = actionPayload.geburtsdatumVn.split('-');
          gebDatum = `${dateSplitted[2]}.${dateSplitted[1]}.${dateSplitted[0]}`;
        }
        return { ...sectionState, geburtsdatum: gebDatum };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
